<template>
  <div id="new-cra-load">
    <div
      class="sidebar-content d-flex flex-column justify-content-start align-items-center"
    >
      <div class="page-title d-flex justify-content-between">
        <div class="d-flex">
          <div class="page-icon">
            <i class="fas fa-credit-card" />
          </div>
          <div class="header-like flex-fill">&nbsp;Add Payment Card</div>
        </div>
        <div class="close-btn">
          <div @click="closePane">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
      <form
        @submit.prevent
        class="form-floating"
        v-if="user"
        id="ccForm"
        v-show="!saveCardSuccess"
      >
        <input type="text" class="d-none" autofocus="true" id="dummy" />

        <div class="payment-type">
          <input
            type="text"
            id="first_name"
            class="form-control"
            :class="{ 'is-invalid': invalidFields.first_name }"
            v-model="first_name"
            @focus="clearError('first_name')"
            placeholder="First Name on Card"
            :disabled="processing"
          />
          <div class="text-danger" v-show="invalidFields.first_name">
            <small>First name is required</small>
          </div>
          <input
            type="text"
            id="last_name"
            class="form-control"
            :class="{ 'is-invalid': invalidFields.last_name }"
            v-model="last_name"
            @focus="clearError('last_name')"
            placeholder="Last Name on Card"
            :disabled="processing"
          />
          <div class="text-danger" v-show="invalidFields.last_name">
            <small>Last name is required</small>
          </div>
          <div class="input-group">
            <div class="input-group-text">
              <CCWidget :cardType="cardType" class="card-widget" />
            </div>
            <input
              type="text"
              id="ccnumber"
              v-model="ccnumber"
              class="form-control"
              :class="{
                'is-invalid': cardType === 'invalid' || invalidFields.ccnumber,
              }"
              @focus="clearError('ccnumber')"
              placeholder="Payment Card Number"
              @input="validateCard"
              :disabled="processing"
            />
          </div>
          <div class="text-danger" v-show="invalidFields.ccnumber">
            <small>Invalid payment card number</small>
          </div>
          <div class="text-danger" v-show="invalidFields.duplicate">
            <small>This card is already saved in your wallet.</small>
          </div>
          <div
            class="expiration-section d-flex justify-content-start align-items-center flex-wrap"
          >
            <div>Expiration</div>
            <div
              class="expiration-block d-flex justify-conent-start align-items-center"
            >
              <div class="flex-fill">
                <select
                  id="month"
                  v-model="month"
                  class="form-select"
                  @focus="clearError('month')"
                  :class="{ 'is-invalid': invalidFields.month }"
                  placeholder="Month"
                  :disabled="processing"
                  @change="validateCard"
                >
                  <option value="01">Jan-1</option>
                  <option value="02">Feb-2</option>
                  <option value="03">Mar-3</option>
                  <option value="04">Apr-4</option>
                  <option value="05">May-5</option>
                  <option value="06">Jun-6</option>
                  <option value="07">Jul-7</option>
                  <option value="08">Aug-8</option>
                  <option value="09">Sep-9</option>
                  <option value="10">Oct-10</option>
                  <option value="11">Nov-11</option>
                  <option value="12">Dec-12</option>
                </select>
              </div>
              <div class="flex-fill">
                <select
                  id="year"
                  v-model="year"
                  class="form-select"
                  @focus="clearError('month')"
                  :class="{ 'is-invalid': invalidFields.month }"
                  placeholder="Year"
                  :disabled="processing"
                  @change="validateCard"
                >
                  <option
                    v-for="(y, i) in years"
                    :key="i"
                    :value="y.toString().slice(2, 4)"
                  >
                    {{ y.toString() }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="expiration-block d-flex justify-conent-start align-items-center"
            >
              <div>CVV</div>
              <div class="flex-fill">
                <input
                  type="text"
                  id="cvv"
                  v-model="cvv"
                  class="form-control"
                  @focus="clearError('cvv')"
                  :class="{ 'is-invalid': invalidFields.cvv }"
                  placeholder="123"
                  :disabled="processing"
                />
              </div>
            </div>
          </div>
          <div class="text-danger" v-show="invalidFields.month">
            <small>Expiration cannot be in the past</small>
          </div>
          <div class="text-danger" v-show="invalidFields.cvv">
            <small>CVV number is invalid</small>
          </div>

          <div class="section-title">Billing Address</div>

          <input
            type="text"
            id="address1"
            :class="{ 'is-invalid': invalidFields.address1 }"
            class="form-control"
            v-model="address1"
            @focus="clearError('address1')"
            placeholder="Street Address"
            :disabled="processing"
          />
          <div class="text-danger" v-show="invalidFields.address1">
            <small>Street address is required</small>
          </div>
          <input
            type="text"
            id="address2"
            class="form-control"
            v-model="address2"
            placeholder="Suite / Apartment"
            :disabled="processing"
          />
          <input
            type="text"
            id="city"
            class="form-control"
            @focus="clearError('city')"
            :class="{ 'is-invalid': invalidFields.city }"
            v-model="city"
            placeholder="City"
            :disabled="processing"
          />
          <div class="text-danger" v-show="invalidFields.city">
            <small>City is required</small>
          </div>
          <select
            id="state"
            v-model="state"
            class="form-select"
            @focus="clearError('state')"
            :class="{ 'is-invalid': invalidFields.state }"
            placeholder="State"
            :disabled="processing"
          >
            <option value="">State</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
          <div class="text-danger" v-show="invalidFields.state">
            <small>State is required</small>
          </div>
          <input
            type="text"
            id="postal"
            class="form-control"
            @focus="clearError('postal')"
            :class="{ 'is-invalid': invalidFields.postal }"
            v-model="postal"
            placeholder="Zip"
            :disabled="processing"
          />
          <div class="text-danger" v-show="invalidFields.postal">
            <small>Valid zip code is required</small>
          </div>
        </div>
        <div>
          <button
            v-show="!processing"
            type="button"
            class="btn btn-success"
            @click="handleSubmit"
            :disabled="processing"
          >
            Save Payment Card
          </button>
          <button v-show="processing" class="btn btn-success" disabled>
            <i class="fas fa-sync fa-spin"></i> Saving Payment Card
          </button>

          <button
            class="btn btn-secondary"
            :disabled="processing"
            @click="backToAccount"
          >
            Cancel
          </button>
        </div>

        <div class="text-danger" v-show="processingError">
          <small>{{ processingError }}</small>
        </div>
      </form>

      <div v-if="saveCardSuccess && savedCard" class="receipt">
        <div class="page-title d-flex justify-content-start">
          <div class="header-like">Success!</div>
        </div>

        <div class="section-title">
          {{ savedCard?.cardTypeNice }}
          ending in {{ savedCard?.ccNumber.substring(12, 16) }} been saved to
          your wallet.
        </div>

        <div v-show="!craEnrollment">
          <hr />
          <h5 class="text-center text-success mt-3">
            Cash Reserve Auto-Reload
          </h5>
          <p>
            <em>
              Save time and avoid declined transactions. Enroll this payment
              card in Cash Reserve Auto-Reload by following these easy steps:
            </em>
          </p>

          <div>
            <auto-reload
              :preSelectCard="savedCard"
              @enrollComplete="enrolled = true"
            />
          </div>
          <hr />
        </div>

        <div v-if="enrolled">
          <hr />
          <p class="text-success text-center fs-5">
            <i class="fa-duotone fa-square-check"></i> Payment Card Successfully
            Enrolled in Auto-Reload!
          </p>
          <hr />
        </div>

        <button class="btn btn-secondary close-btn" @click="backToAccount">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import valid from "card-validator";
import { log, api, gaEvent, gaError } from "@/utils/utils";
import CCWidget from "@/components/CashApp/Shared/CCWidget.vue";
import currency from "currency.js";
import AutoReload from "../Account/AutoReload.vue";

export default {
  name: "AddCard",
  components: {
    CCWidget,
    AutoReload,
  },
  data() {
    return {
      paymentType: undefined,

      processing: false,
      amount: currency(50),
      first_name: "",
      last_name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      postal: "",
      ccnumber: "",
      cvv: "",
      formUrl: undefined,
      cardType: undefined,
      cardTypeNice: undefined,
      allowCardSubmit: false,
      cvvLength: 3,
      month: "01",
      year: new Date().getFullYear().toString().slice(2, 4),
      years: [new Date().getFullYear()].reduce((col, c) => {
        for (var j = c; j < c + 20; j++) {
          col.push(j);
        }
        return col;
      }, []),
      saveCardSuccess: false,
      invalidFields: {},
      processingError: false,
      receipt: undefined,

      selectedWalletItem: undefined,
      selectedCardType: undefined,
      selectedCardTypeNice: undefined,

      deletingPaymentMethod: false,
      savedCard: undefined,
      enrolled: false,
    };
  },
  props: {},
  computed: {
    ...mapState({
      showLeftBar: (state) => state.app.all.showLeftBar,
      user: (state) => state.app.all.user,
    }),
    wallet() {
      return (
        this.user &&
        Object.keys(this.user.wallet).reduce((col, k) => {
          if (this.user.wallet[k]) {
            const val = JSON.parse(JSON.stringify(this.user.wallet[k]));

            val.expired =
              parseInt(
                `${val.ccExp.substring(2, 4)}${val.ccExp.substring(0, 2)}`
              ) <
              parseInt(
                new Date()
                  .toISOString()
                  .split("T")[0]
                  .replace(/-/g, "")
                  .slice(2, 6)
              );

            col.push(val);
          }
          return col;
        }, [])
      );
    },
    craEnrollment() {
      for (const k in this.wallet) {
        if (this.wallet[k]?.autoReloadAmount) {
          return this.wallet[k];
        }
      }
      return false;
    },
    duplicateCard() {
      return !!this.wallet.find((w) => {
        return (
          w.ccNumber.length === this.ccnumber.length &&
          w.ccNumber.substring(0, 6) === this.ccnumber.substring(0, 6) &&
          w.ccNumber.substring(12, 16) === this.ccnumber.substring(12, 16) &&
          `${this.month}${this.year}` === w.ccExp
        );
      });
    },
  },
  watch: {
    wallet(post) {
      if (!this.paymentType) {
        this.paymentType = post.length > 0 ? "wallet" : "cc";
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("dummy").focus();
    });
  },
  methods: {
    quickLog(e) {
      console.log(e);
    },
    clearReceipt() {
      this.receipt = undefined;
    },
    clearForm() {
      this.processing = false;
      this.first_name = "";
      this.last_name = "";
      this.address1 = "";
      this.address2 = "";
      this.city = "";
      this.state = "";
      this.postal = "";
      this.ccnumber = "";
      this.cvv = "";
      this.formUrl = undefined;
      this.cardType = undefined;
      this.cardTypeNice = undefined;
      this.allowCardSubmit = false;
      this.cvvLength = 3;
      this.month = "01";
      this.year = new Date().getFullYear().toString().slice(2, 4);
      this.years = [new Date().getFullYear()].reduce((col, c) => {
        for (var j = c; j < c + 20; j++) {
          col.push(j);
        }
        return col;
      }, []);
      this.saveCardSuccess = false;
      this.invalidFields = {};
      this.processingError = false;
      this.selectedCardType = undefined;
      this.selectedCardTypeNice = undefined;
      this.enrolled = false;
    },
    validateCard() {
      console.log(this.duplicateCard, this.wallet);

      const v = valid.number(this.ccnumber);

      this.allowCardSubmit = false;

      if (!v.isPotentiallyValid) {
        this.cardType = "invalid";
      } else if (!v.card) {
        this.cardType = undefined;
        this.cardTypeNice = undefined;
      } else if (v.card.type) {
        this.cardType = v.card.type;
        this.cardTypeNice = v.card.niceType;
      }

      if (this.duplicateCard) this.invalidFields.duplicate = true;

      if (v.isValid && v.isPotentiallyValid) {
        this.allowCardSubmit = true;
      }

      this.cvvLength =
        v.card && v.card.code && v.card.code.size ? v.card.code.size : 3;
    },
    clearError(key) {
      this.invalidFields[key] = undefined;
    },
    handleSubmit() {
      this.doValidation();
    },
    doValidation() {
      this.processing = true;
      this.invalidFields = {};
      this.formUrl = undefined;
      this.processingError = false;

      if (!this.amount || this.amount < 10) this.invalidFields.amount = true;
      if (this.first_name === "") this.invalidFields.first_name = true;
      if (this.last_name === "") this.invalidFields.last_name = true;
      if (!this.allowCardSubmit) this.invalidFields.ccnumber = true;

      if (
        parseInt(`${this.year}${this.month}`) <
        parseInt(
          new Date().toISOString().split("T")[0].replace(/-/g, "").slice(2, 6)
        )
      )
        this.invalidFields.month = true;
      if (this.cvv.length !== this.cvvLength) this.invalidFields.cvv = true;
      if (this.address1 === "") this.invalidFields.address1 = true;
      if (this.city === "") this.invalidFields.city = true;
      if (this.state === "") this.invalidFields.state = true;
      if (this.postal === "" || !this.postal || !/(^\d{5}$)/.test(this.postal))
        this.invalidFields.postal = true;

      if (this.duplicateCard) this.invalidFields.duplicate = true;

      if (Object.keys(this.invalidFields).length === 0) {
        this.runCard();
      } else {
        this.processingError = "Please review and correct the issues above.";
        this.processing = false;
      }
    },
    async runCard() {
      this.processing = true;
      this.saveCardSuccess = false;

      try {
        const v1 = await api("post", "banking", `/vault/stepone/`, {
          body: {
            first_name: this.first_name,
            last_name: this.last_name,
            address1: this.address1,
            address2: this.address2,
            city: this.city,
            state: this.state,
            postal: this.postal,
            cardType: this.cardType,
            cardTypeNice: this.cardTypeNice,
          },
        });

        console.log(v1.formUrl, "test");

        let vaultFormData = new FormData();
        vaultFormData.append(
          "billing-cc-number",
          this.ccnumber.replace(/\s/g, "")
        );
        vaultFormData.append("billing-cc-exp", `${this.month}${this.year}`);
        vaultFormData.append("billing-cvv", this.cvv);

        const v2 = await fetch(v1.formUrl, {
          method: "POST",
          // headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(vaultFormData),
        });

        const vaultRes = await v2.json();
        if (vaultRes.error) throw vaultRes;

        console.log("Add to vault response:", vaultRes);

        if (vaultRes.wallet) {
          this.updateAppStore({ user: vaultRes });
        }

        this.savedCard = this.wallet.find((w) => {
          return (
            w.ccNumber.length === this.ccnumber.length &&
            w.ccNumber.substring(0, 6) === this.ccnumber.substring(0, 6) &&
            w.ccNumber.substring(12, 16) === this.ccnumber.substring(12, 16) &&
            `${this.month}${this.year}` === w.ccExp
          );
        });

        this.saveCardSuccess = true;

        gaEvent("cra_wallet_save", "banking");

        log({
          m: "Saved card to wallet.",
          partition: "banking",
        });
      } catch (e) {
        this.processingError =
          "An error occurred. Unable to save payment method. Please try again later.";
        gaError(`cra_wallet_save: ${e.error}`);
        console.log("Error in savinging to vault:", e.error || e);
        log({
          m: "Error saving card to wallet.",
          e: e,
          partition: "banking",
        });
      } finally {
        this.processing = false;
      }
    },
    printDiv(divName) {
      const printContents = document.getElementById(divName).innerHTML;
      const w = window.open();
      w.document.write(printContents);
      w.print();
      w.close();
    },
    async deletePaymentMethod(id) {
      this.deletingPaymentMethod = true;
      this.processingError = undefined;

      try {
        await api("post", "banking", `/vault/delete/`, {
          body: {
            vaultId: id,
          },
        });

        const tempUser = JSON.parse(JSON.stringify(this.user));
        tempUser.wallet[id] = undefined;
        this.updateAppStore({ user: tempUser });

        if (this.wallet.length === 0) {
          this.paymentType = "cc";
        }

        if (id === this.selectedWalletItem) {
          this.selectedWalletItem = undefined;
          this.selectedCardType = undefined;
          this.selectedCardTypeNice = undefined;
        }
      } catch (e) {
        if (e.error) {
          this.processingError = e.error;
        } else {
          this.processingError =
            "An error occurred. Unable to delete payment method. Please try again later.";
          throw e;
        }
      } finally {
        this.deletingPaymentMethod = false;
      }
    },
    closePane() {
      this.clearForm();
      this.clearReceipt();
      this.$emit("cancel");
    },
    backToAccount() {
      this.clearForm();
      this.clearReceipt();
      this.$emit("clickedShortcut", "Account");
    },
    backToCRA() {
      this.clearForm();
      this.clearReceipt();
      this.$emit("clickedShortcut", "LoadCRA");
    },
    ...mapActions({
      updateAppStore: "app/updateAppStore",
    }),
  },
  beforeMount() {},
  activated() {},
};
</script>

<style scoped>
#new-cra-load {
  background-color: white;
  color: var(--ms-dark);
  font-size: 18px;
  line-height: 22px;
}
.sidebar-content {
  padding: 30px 0;
}

.mx-dark {
  color: var(--mx-dark);
}

.title {
  font-weight: 600;
}

.mx-dark {
  color: var(--mx-dark);
}

.title {
  font-weight: 600;
}

form {
  position: relative;
  margin-top: 35px;
  width: 100%;
  height: 100%;
  padding: 0 30px;
}

.input-group,
.form-control:not(.input-group .form-control),
select {
  margin: 15px 0;
}

.input-group-text {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.section {
  margin: 60px 0 0;
  padding: 30px 30px;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

.section:last-child {
  margin: 60px 0;
}

.section-title {
  font-size: 20px;
  line-height: 24px;
}

.section-title span {
  font-size: 16px;
  margin: 0 0 0 10px;
  font-style: italic;
}

.section-title:not(:first-of-type) {
  margin: 30px 0 0;
}

.form-control {
  display: inline-block;
  font-size: 18px;
  line-height: 22px;
  padding: 21px 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #c4c4c4;
  font-style: italic;
}

.form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-check-input {
  padding: 12px;
  height: 24px;
  width: 24px;
  margin: 0;
}

.form-check-label {
  margin: 0 0 0 20px;
}

.check-control {
  margin: 15px 0;
  display: flex;
}

select {
  font-size: 18px;
  line-height: 22px;
  padding: 21px 20px;
  font-style: italic;
  border-radius: 12px;
  border: 1px solid #c4c4c4;
}

.expiration-section {
  margin: 30px 0 0;
  width: 100%;
}

.expiration-block {
  width: 100%;
  max-width: 500px;
}

.expiration-block div {
  margin: 0 15px 0 0;
}

.exp-holder {
  width: 600px;
}

.expiration {
  width: 100%;
  max-width: 150px;
}

.expiration:not(:last-of-type) {
  margin: 15px 20px 15px 0;
}

.btn-success {
  margin: 35px 0;
  border-color: var(--mx-green);
  background-color: var(--mx-green);
  font-size: 18px;
  line-height: 27px;
  padding: 15px 0;
  border-radius: 12px;
  width: 100%;
  max-width: 475px;
}

.btn-secondary {
  margin: 15px 0 35px;
  border-color: var(--mx-grey);
  background-color: var(--mx-grey);
  font-size: 18px;
  line-height: 27px;
  padding: 15px 0;
  border-radius: 12px;
  width: 100%;
  max-width: 475px;
}

.error {
  font-size: 18px;
  line-height: 27px;
}

.page-title {
  width: 100%;
  font-size: 30px;
  line-height: 36px;
  font-weight: 500;
  color: var(--mx-dark);
  padding: 0 30px;
}

.page-icon {
  margin: 0 10px 0 0;
}

.receipt {
  padding: 30px 30px 0;
}

.receipt > .page-title {
  padding: 0;
}

.section-text {
  margin: 15px 0;
}

.receipt-cc {
  height: 36px;
  width: 70px;
  margin: 0 5px;
}

.transaction-details {
  padding: 15px 30px;
}

.receipt-print {
  cursor: pointer;
  border-bottom: 1px dotted var(--mx-grey);
}

#receipt-print,
#receipt-print-old {
  display: none;
}

.close-btn {
  cursor: pointer;
}

.card-widget {
  height: 36px;
  font-size: 36px;
  width: 50px;
}

.wallet-item {
  padding: 30px;
  background-color: #fcfcfc;
  border-radius: 20px;
  margin: 15px 0;
  cursor: pointer;
}

.wallet-item.is-invalid {
  background-color: #f8d7da;
  cursor: default;
}

.wallet-item:not(.is-invalid):hover,
.wallet-item.selected {
  background-color: #00af6c1c;
}

.wallet-item-inner > div {
  margin: 0 20px 0 0;
  line-height: 36px;
}

.wallet-select {
  margin: 0 20px 0 0;
}

.wallet-warn {
  margin: 10px 0 0 0;
}

.select-payment-type {
  margin: 30px 0 0;
}

.mx-alert div:first-child {
  font-size: 30px;
}

mx-alert:not(:first-child) {
  margin: 15px 0 0;
}

.alert-text {
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  margin: 0 0 0 10px;
}

.promo-text {
  font-size: 17px;
  line-height: 20px;
  font-weight: 300;
  margin: 0 0 0 10px;
}

.promo-icon {
  font-size: 50px;
}

.mx-alert-link {
  cursor: pointer;
  border-bottom: 1px dotted var(--mx-grey);
}
</style>
